import { graphql, useStaticQuery } from 'gatsby';
import { KiteIcon } from '@kite/react-kite';
import React, { useEffect, useState } from 'react';
import { ReachButton } from '../ReachButton/ReachButton';
import { SmartLink } from '../../components/SmartLink/SmartLink';
import { TwoColumnTextImage } from '../TwoColumnTextImage/TwoColumnTextImage';
import { useLayoutContext } from '../../providers/LayoutProvider';
import './CityBlock.scss';
import { DriftChatButton } from '../DriftChatButton/DriftChatButton';

export const CityBlock = () => {
    const { quizResults } = useLayoutContext();
    const [data, setData] = useState<any>({});

    const {
        allNodeCityPage: { nodes: cities },
        mediaImage,
    } = useStaticQuery(graphql`
        query {
            allNodeCityPage(sort: {changed: DESC}) {
                nodes {
                    field_heading
                    field_subheading
                    field_dma_address
                    title
                    field_zipcodes
                    fields {
                        url
                    }
                    relationships {
                        field_hero_image {
                            relationships {
                                field_media_image {
                                    localFile {
                                        childImageSharp {
                                            ...ImageConstrainedOneHalfSettings
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            mediaImage(name: { eq: "City_Block_National_Map" }) {
                relationships {
                    field_media_image {
                        localFile {
                            childImageSharp {
                                ...ImageConstrainedOneHalfSettings
                            }
                        }
                    }
                }
            }
        }
    `);

    useEffect(() => {
        const cityMatch = cities.find(
            (city) =>
                city.field_zipcodes &&
                quizResults?.zipcode?.length === 5 &&
                city.field_zipcodes.includes(quizResults?.zipcode)
        );

        if (cityMatch) {
            setData({
                image: cityMatch.relationships?.field_hero_image,
                fieldHeading: `Learn more about ** your local market. **`,
                title: (
                    <li>
                        <span className="map-icon-container">
                            <KiteIcon size="1.3rem" icon="ki-map-point-f" />
                        </span>
                        <span>{cityMatch.title}</span>
                    </li>
                ),
                marketDetailsButton: (
                    <div className="market-details-button buttons">
                        <ReachButton
                            href={cityMatch.fields.url}
                            buttonStyle="primary"
                        >
                            View Market Details
                        </ReachButton>
                    </div>
                ),
                paragraphText: quizResults?.multipleLocations && (
                    <p className="city-block-market">
                        Looking for details on another area?
                    </p>
                ),
                marketsMapButton: quizResults?.multipleLocations && (
                    <div className="buttons">
                        <ReachButton
                            href="/markets-map"
                            buttonStyle="secondary"
                        >
                            View the Markets Map
                        </ReachButton>
                    </div>
                ),
            });
        } else {
            setData({
                image: mediaImage,
                paragraphText: (
                    <p className="city-block-market">
                        Looking for details on another area?
                    </p>
                ),
                fieldHeading: `Learn about the ** markets you can reach. **`,
                marketsMapButton: (
                    <div className="buttons">
                        <ReachButton
                            href="/markets-map"
                            buttonStyle="secondary"
                        >
                            View the Markets Map
                        </ReachButton>
                    </div>
                ),
            });
        }
    }, [quizResults]);

    return (
        <TwoColumnTextImage
            node={{
                field_theme: `white`,
                field_lr_align: `left`,
                relationships: {
                    field_image: data.image,
                    field_text: {
                        field_heading: data.fieldHeading,
                        field_eyebrow_text: ``,
                        field_content_text: {
                            value: ``,
                        },
                        field_link: ``,
                    },
                },
            }}
        >
            <ul className="list-city-block">
                {data.title}
                <li>
                    <KiteIcon size="1.3rem" icon="ki-compose-f" />
                    <SmartLink href="/contact">
                        Connect with an expert
                    </SmartLink>
                </li>
                <li>
                    <KiteIcon size="1.3rem" icon="ki-chat-f" />
                    <DriftChatButton />
                </li>

                <li>
                    <KiteIcon size="1.3rem" icon="ki-phone-f" />
                    <SmartLink href="tel:+1-844-To-Reach">
                        1-844-To-Reach
                    </SmartLink>
                </li>
            </ul>
            {data?.marketDetailsButton}
            {data?.paragraphText}
            {data?.marketsMapButton}
        </TwoColumnTextImage>
    );
};
